/* unplugin-vue-components disabled */import { render } from "./tracker-segment.vue?vue&type=template&id=15fa5bfd&scoped=true"
import script from "./tracker-segment.vue?vue&type=script&lang=js"
export * from "./tracker-segment.vue?vue&type=script&lang=js"

import "./tracker-segment.vue?vue&type=style&index=0&id=15fa5bfd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fa5bfd"],['__file',"src/pages/pulse/tracker/tracker-segment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15fa5bfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15fa5bfd', __exports__)) {
    api.reload('15fa5bfd', __exports__)
  }
  
  module.hot.accept("./tracker-segment.vue?vue&type=template&id=15fa5bfd&scoped=true", () => {
    api.rerender('15fa5bfd', render)
  })

}


export default __exports__